import { Link } from 'react-router-dom';
import { videos } from '@/mocks/home';
import { fetchVideoList } from '@/services/video';
import { adaptVideos } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import SectionHeading from '@/components/base/SectionHeading';

const HOME_LIMIT = 8;

export default function VideosSection() {
  // 接口失败时降级为 mock 数据
  const { data: videoList } = useRequest(
    () => fetchVideoList({ pageIndex: 1, pageSize: HOME_LIMIT }).then((res) => adaptVideos(res.list)),
    { fallback: videos.slice(0, HOME_LIMIT) },
  );

  // 无数据时整段隐藏，避免出现只有标题与按钮的空板块
  if (videoList.length === 0) return null;

  return (
    <section id="videos" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="视频中心"
          title="国医风云录，影像中的传承"
          description="以纪录片视角走近国医大师，记录中西医结合之路的探索与实践。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {videoList.map((video) => (
            <Link key={video.id} to={`/videos/${video.id}`} className="group cursor-pointer">
              <div className="relative w-full h-[180px] rounded-lg overflow-hidden mb-4">
                <img
                  src={video.image}
                  alt={video.title}
                  title={`${video.title} - 视频专区`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/25 group-hover:bg-foreground-950/40 transition-colors"></div>
                <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className="ri-play-fill text-2xl"></i>
                </span>
                {video.duration && (
                  <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs">
                    {video.duration}
                  </span>
                )}
                <span className="absolute top-2 left-2 px-2.5 py-0.5 rounded-full bg-background-50/90 backdrop-blur text-xs font-medium text-accent-700">
                  {video.category}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 leading-snug text-balance mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                {video.title}
              </h3>
              <div className="flex items-center justify-end text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {video.views}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/videos"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部视频
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}